<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div
                class="row align-items-end mt-0 pagination-body row-set-line"
              >
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <button
                    class="btn enrollment-list-buttons cursor-pointer"
                    type="button"
                    *ngFor="let status of status_list"
                    [ngClass]="{
                      'btn-primary': activeTab == status?.id,
                      'btn-outline-primary': activeTab != status?.id
                    }"
                    (click)="activeClassTab(status?.id)"
                  >
                    {{ status.name }}
                  </button>
                </div>

                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <!-- <div class="col-flex-2 mb-1">
                      <ng-select [items]="type_list" bindLabel="name" placeholder="Select Type"
                        [(ngModel)]="select_classType" [ngModelOptions]="{ standalone: true }" [closeOnSelect]="false"
                        (change)="getTypeId($event)">
                      </ng-select>
                    </div> -->

                    <div
                      class="col-flex-2 mb-1"
                      *ngIf="activeTab === 'upcoming'"
                    >
                      <button
                        class="btn btn-danger btn-block users-list-clear glow mb-0"
                        (click)="deleteAllUpcomingClasses()"
                      >
                        Delete Upcoming
                      </button>
                    </div>

                    <div class="col-flex-2 mb-1 position-relative">
                      <input
                        id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text"
                        placeholder="Search"
                        #name
                        [(ngModel)]="searchVal"
                        (keydown.enter)="getFilter()"
                      />
                      <button
                        class="btn search-btn glow position-absolute"
                        (click)="getFilter()"
                      >
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>

                    <div class="col-flex-2 mb-1">
                      <button
                        class="btn btn-primary btn-block users-list-clear glow mb-0 reset-btn"
                        (click)="resetFilter()"
                      >
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>

                    <div
                      class="col-flex-2 mb-1"
                      *ngIf="
                        user_role.roles == 'admin' ||
                        user_role.roles == 'employee' ||
                        user_role.roles == 'extractor'
                      "
                    >
                      <!-- <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0" placement="top" ngbTooltip="Add New">
                          +
                        </button> -->
                      <div ngbDropdown class="d-inline-block">
                        <button
                          class="btn btn-primary btn-block glow mb-0"
                          placement="top"
                          ngbTooltip="Add New"
                          ngbDropdownToggle
                        >
                          +
                        </button>
                        <div ngbDropdownMenu>
                          <button
                            [hidden]="activeTab == 'pattern'"
                            ngbDropdownItem
                            routerLink="/classes/add-update-class-byBatch"
                          >
                            Class by Batch
                          </button>
                          <button
                            [hidden]="activeTab == 'pattern'"
                            ngbDropdownItem
                            routerLink="/classes/add-update-class-byStduent"
                          >
                            Class by Student
                          </button>
                          <button
                            *ngIf="activeTab === 'pattern'"
                            ngbDropdownItem
                            [routerLink]="[
                              '/classes/add-update-class-byStduent'
                            ]"
                            [queryParams]="{ status: 'pattern' }"
                          >
                            Class by Student
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2"
                >
                  <ngx-datatable
                    class="bootstrap core-bootstrap"
                    [columnMode]="ColumnMode.force"
                    [headerHeight]="40"
                    [footerHeight]="40"
                    rowHeight="auto"
                    [limit]="limitRef"
                    [rows]="rows"
                    [externalPaging]="true"
                    [count]="page.totalPages"
                    [offset]="page.pageNumber"
                    (page)="pageChangeData($event)"
                  ></ngx-datatable>
                </div>

                <!-- <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary"
                    (click)="openDynamicModal(guideline_data)">Classes Guideline</button>
                </div>
                <div class="col-12">
                  <button *ngIf="activeTab == 'pattern'" mat-menu-item (click)="openPopup(row._id)">Create Class</button>
                </div> -->

                <div
                  class="col-12 d-flex justify-content-between align-items-center mb-2"
                >
                  <div class="d-flex align-items-center">
                    <button
                      *ngIf="guideline_data"
                      class="btn btn-outline-primary mr-2"
                      (click)="openDynamicModal(guideline_data)"
                    >
                      Classes Guideline
                    </button>

                    <!-- Checkbox to show deactivated patterns -->
                    <div
                      *ngIf="activeTab == 'pattern'"
                      class="custom-control custom-checkbox"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="showDeactivatedCheckbox"
                        [(ngModel)]="showDeactivated"
                        (ngModelChange)="toggleDeactivated()"
                      />
                      <label
                        class="custom-control-label"
                        for="showDeactivatedCheckbox"
                      >
                        Show Deactivated Patterns
                      </label>
                    </div>
                  </div>

                  <button
                    *ngIf="activeTab == 'pattern'"
                    class="btn btn-primary"
                    (click)="openPopups()"
                  >
                    Create Class
                  </button>
                </div>
              </div>
            </fieldset>

            <ngx-datatable
              class="bootstrap core-bootstrap"
              [columnMode]="ColumnMode.force"
              [headerHeight]="50"
              [footerHeight]="50"
              rowHeight="auto"
              [limit]="limitRef"
              [rows]="rows"
              [scrollbarH]="true"
              [columns]="columns"
              [externalPaging]="true"
              [count]="page.totalPages"
              [offset]="page.pageNumber"
              (page)="pageChangeData($event)"
            >
              <ngx-datatable-column name="Title" prop="title" [width]="100">
                <ng-template
                  let-row="row"
                  let-name="value"
                  ngx-datatable-cell-template
                >
                  <div class="d-flex align-items-center">
                    <div class="cell-line-height cursor-pointer">
                      <p
                        (click)="viewTopics(row)"
                        class="font-medium-1 line-height-1 mb-1"
                        [style.opacity]="row?.isDeactivated ? '0.5' : '1'"
                        [style.text-decoration]="
                          row?.isDeactivated ? 'line-through' : 'none'
                        "
                      >
                        {{ row?.title | titlecase }}
                        <span
                          *ngIf="row?.isDeactivated"
                          class="badge badge-warning ml-1"
                          >Deactivated</span
                        >
                      </p>

                      <p
                        *ngIf="row?.instructor?.name"
                        ngbTooltip="Instructor"
                        class="bg-light-primary font-small-2 line-height-1 mb-0 p-1 rounded"
                      >
                        {{ row?.instructor?.name | titlecase }}
                      </p>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="References" prop="refrences" [width]="200">
  <ng-template let-row="row" ngx-datatable-cell-template>
    <ng-container *ngIf="row?.refrences?.name && row?.refrences?.links; else noRef">
      <a [href]="row.refrences.links" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #007bff;">
        {{ row.refrences.name }}
      </a>
      <i class="ft-edit ml-1 text-primary cursor-pointer" (click)="editRef(row.refrences)"></i>
    </ng-container>
    <ng-template #noRef>-</ng-template>
  </ng-template>
</ngx-datatable-column> -->
              <ngx-datatable-column
                name="References"
                prop="refrences"
                [width]="250"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div
                    class="d-flex flex-wrap align-items-center"
                    style="gap: 8px"
                  >
                    <!-- Reference Tags -->
                    <ng-container
                      *ngIf="row?.refrences?.name && row?.refrences?.links"
                    >
                      <span class="reference-tag">
                        <a
                          [href]="row.refrences.links"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="reference-link"
                        >
                          {{ row.refrences.name }}
                        </a>
                        <i
                          class="ft-edit ml-1 cursor-pointer reference-edit-icon"
                          (click)="editRef(row.refrences)"
                          ngbTooltip="Edit Reference"
                          placement="top"
                        ></i>
                      </span>
                    </ng-container>

                    <!-- Add Reference Button - Always visible -->
                    <button
                      class="btn btn-sm btn-add-reference"
                      (click)="createRefForClass(row)"
                      ngbTooltip="Add Reference"
                      placement="top"
                    >
                      <i class="ft-plus mr-1"></i>Add Reference
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="References" prop="refrences" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <a *ngIf="row?.refrences?.name && row?.refrences?.links" [href]="row.refrences.links" target="_blank"
                    rel="noopener noreferrer" style="text-decoration: underline; color: #007bff;">
                    {{ row.refrences.name }}
                  </a>
                  <span *ngIf="!row?.refrences?.name || !row?.refrences?.links">-</span>
                </ng-template>
              </ngx-datatable-column> -->
              <!-- <ngx-datatable-column name="Project Tag" prop="project_tag" [width]="100">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row?.project_tag?.name || '—' }}
                </ng-template>
              </ngx-datatable-column> -->

              <!-- <ngx-datatable-column name="Date" prop="date" [width]="15" [hidden]="activeTab ==='pattern'">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{ row?.date | date:'mediumDate' }}
                </ng-template>
              </ngx-datatable-column> -->

              <ngx-datatable-column
                name="Project Tag"
                prop="project_tag"
                [width]="120"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span
                    class="cursor-pointer text-primary"
                    (click)="openProjectTagModal(row)"
                    *ngIf="row?.project_tag"
                  >
                    {{
                      row.project_tag.name ||
                        row.project_tag.displayname ||
                        row.project_tag
                    }}
                  </span>
                  <span class="text-muted" *ngIf="!row?.project_tag">—</span>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="Students" prop="students" [width]="180">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="cursor-pointer text-primary" (click)="openStudentModal(row)">
                    {{ row?.students?.length ? row.students.length + ' Student(s)' : '—' }}
                  </span>
                </ng-template>
              </ngx-datatable-column> -->

              <ngx-datatable-column
                name="Students"
                prop="students"
                [width]="250"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span
                    class="cursor-pointer text-primary"
                    (click)="openStudentModal(row)"
                  >
                    {{
                      row?.students?.topic_info?.length
                        ? row.students.topic_info.length + " Student(s)"
                        : "+"
                    }}
                  </span>
                  <div *ngIf="row?.students?.length">
                    <small class="text-muted">
                      {{ getStudentNames(row) }}
                    </small>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Date" prop="date" [width]="250">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <!-- Normal display -->
                  <div
                    *ngIf="editingDateRow !== row._id"
                    class="d-flex align-items-center"
                  >
                    <span
                      (click)="editingDateRow = row._id"
                      class="cursor-pointer text-primary"
                    >
                      {{ row.date | date : "mediumDate" }}
                      <i class="ft-edit ml-1 small text-muted"></i>
                    </span>
                  </div>

                  <!-- Date picker input -->
                  <div
                    *ngIf="editingDateRow === row._id"
                    class="d-flex align-items-center gap-1"
                  >
                    <mat-form-field appearance="fill" class="date-field m-0">
                      <mat-label class="date-label">Date</mat-label>
                      <input
                        type="date"
                        matInput
                        [(ngModel)]="row.date"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </mat-form-field>

                    <!-- Save button for single update -->
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="saveDate(row._id, row)"
                      ngbTooltip="Save (Single Class)"
                    >
                      <i class="ft-check"></i>
                    </button>

                    <!-- <button mat-icon-button color="primary" (click)="saveDate(row._id, row)" matTooltip="Save">
                      <i class="ft-check"></i>
                    </button> -->
                    <!-- Save button for sequence update -->
                    <button
                      *ngIf="activeTab === 'pattern'"
                      mat-icon-button
                      color="primary"
                      (click)="saveDate(row._id, row, 'sequence')"
                      ngbTooltip="Save (Sequence Classes)"
                    >
                      <i class="ft-check"></i>
                    </button>
                    <!-- <button *ngIf="activeTab === 'pattern'" mat-icon-button color="primary"
                      (click)="saveDate(row._id, row, 'sequence')" matTooltip="Save Sequence">
                      <i class="ft-check"></i>
                    </button> -->

                    <!-- Cancel button -->
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="editingDateRow = null"
                      matTooltip="Cancel"
                    >
                      <i class="ft-x"></i>
                    </button>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="Time" prop="time" [width]="5">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{ row?.start_time | convertTo12Hour }} - {{ row?.end_time | convertTo12Hour }}
                </ng-template>
              </ngx-datatable-column> -->

              <ngx-datatable-column name="Time" prop="time" [width]="200">
                <ng-template
                  let-row="row"
                  let-rowIndex="rowIndex"
                  ngx-datatable-cell-template
                >
                  <ng-container
                    *ngIf="editingTimeRow === row._id; else displayTime"
                  >
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="fill" class="mr-1">
                        <mat-label>Start Time</mat-label>
                        <input
                          matInput
                          [(ngModel)]="editedStartTime"
                          type="time"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="mr-1">
                        <mat-label>End Time</mat-label>
                        <input
                          matInput
                          [(ngModel)]="editedEndTime"
                          type="time"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      </mat-form-field>
                      <button
                        mat-icon-button
                        color="primary"
                        (click)="saveTime(row)"
                        ngbTooltip="Save (Single Class)"
                      >
                        <i class="ft-check"></i>
                      </button>
                      <button
                        *ngIf="activeTab === 'pattern'"
                        mat-icon-button
                        color="primary"
                        (click)="saveTime(row, 'sequence')"
                        ngbTooltip="Save (Sequence Classes)"
                      >
                        <i class="ft-check"></i>
                      </button>
                      <button
                        mat-icon-button
                        color="warn"
                        (click)="cancelTimeEdit()"
                      >
                        <i class="ft-x"></i>
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #displayTime>
                    <span
                      (click)="editTime(row)"
                      class="cursor-pointer text-primary"
                    >
                      {{ row?.start_time | convertTo12Hour }} -
                      {{ row?.end_time | convertTo12Hour }}
                    </span>
                  </ng-template>

                  <div class="mt-1" *ngIf="row?.pattern_schedule">
                    <span
                      *ngFor="let day of getActiveDays(row.pattern_schedule)"
                      class="day-badge"
                    >
                      {{ day }}
                    </span>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Notes" prop="notes" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <ng-container
                    *ngIf="editingNotesRow === row._id; else displayNotes"
                  >
                    <div
                      class="d-flex flex-wrap align-items-start"
                      style="gap: 0.5rem"
                    >
                      <textarea
                        class="form-control mb-1"
                        [(ngModel)]="editedNotes"
                        rows="1"
                        [ngModelOptions]="{ standalone: true }"
                        style="width: 80px"
                      ></textarea>
                      <div class="d-flex flex-column">
                        <button
                          class="btn btn-sm btn-primary mr-1"
                          (click)="saveNotes(row)"
                        >
                          Save
                        </button>
                        <button
                          *ngIf="activeTab === 'pattern'"
                          class="btn btn-sm btn-primary mr-1"
                          (click)="saveNotes(row, 'sequence')"
                        >
                          Sequence
                        </button>
                        <button
                          class="btn btn-sm btn-secondary"
                          (click)="cancelNotesEdit()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #displayNotes>
                    <span
                      (click)="editNotes(row)"
                      class="cursor-pointer text-primary"
                      >{{ row?.notes || "—" }}</span
                    >
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Admin Notes"
                prop="admin_notes"
                [width]="100"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <ng-container
                    *ngIf="
                      editingAdminNotesRow === row._id;
                      else displayAdminNotes
                    "
                  >
                    <div
                      class="d-flex flex-wrap align-items-start"
                      style="gap: 0.5rem"
                    >
                      <textarea
                        class="form-control mb-1"
                        [(ngModel)]="editedAdminNotes"
                        rows="1"
                        [ngModelOptions]="{ standalone: true }"
                      ></textarea>
                      <div class="d-flex flex-column">
                        <button
                          class="btn btn-sm btn-primary mr-1"
                          (click)="saveAdminNotes(row)"
                        >
                          Save
                        </button>
                        <button
                          *ngIf="activeTab === 'pattern'"
                          class="btn btn-sm btn-primary mr-1"
                          (click)="saveAdminNotes(row, 'sequence')"
                        >
                          Sequence
                        </button>
                        <button
                          class="btn btn-sm btn-secondary"
                          (click)="cancelAdminNotesEdit()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #displayAdminNotes>
                    <span
                      (click)="editAdminNotes(row)"
                      class="cursor-pointer text-primary"
                      >{{ row?.admin_notes || "—" }}</span
                    >
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Zoom Link"
                prop="zoom_link"
                [width]="250"
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <!-- Only show zoom link for LIVE classes -->
                  <ng-container
                    *ngIf="
                      row?.project_tag?.name === 'LIVE' ||
                      row?.project_tag?.displayname === 'LIVE'
                    "
                  >
                    <ng-container
                      *ngIf="
                        editingZoomLinkRow === row._id;
                        else displayZoomLink
                      "
                    >
                      <div
                        class="d-flex flex-wrap align-items-start"
                        style="gap: 0.5rem"
                      >
                        <input
                          type="text"
                          class="form-control mb-1"
                          [(ngModel)]="editedZoomLink"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Enter zoom link"
                        />
                        <div class="d-flex flex-column">
                          <button
                            class="btn btn-sm btn-primary mr-1"
                            (click)="saveZoomLink(row)"
                          >
                            Save
                          </button>
                          <button
                            *ngIf="activeTab === 'pattern'"
                            class="btn btn-sm btn-primary mr-1"
                            (click)="saveZoomLink(row, 'sequence')"
                          >
                            Sequence
                          </button>
                          <button
                            class="btn btn-sm btn-secondary"
                            (click)="cancelZoomLinkEdit()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #displayZoomLink>
                      <span
                        *ngIf="row?.zoom_link"
                        class="d-flex align-items-center"
                      >
                        <span
                          class="cursor-pointer text-primary"
                          (click)="copyZoomLink(row.zoom_link)"
                          ngbTooltip="Click to copy link"
                        >
                          <i class="ft-video mr-1"></i>Join Zoom
                        </span>
                        <i
                          class="ft-edit ml-1 small text-muted cursor-pointer"
                          (click)="editZoomLink(row)"
                          ngbTooltip="Edit link"
                        ></i>
                      </span>
                      <span
                        *ngIf="!row?.zoom_link"
                        (click)="editZoomLink(row)"
                        class="cursor-pointer text-primary"
                      >
                        <i class="ft-plus mr-1"></i>Add Link
                      </span>
                    </ng-template>
                  </ng-container>
                  <!-- Show dash for DESK classes -->
                  <span
                    *ngIf="
                      row?.project_tag?.name !== 'LIVE' &&
                      row?.project_tag?.displayname !== 'LIVE'
                    "
                    >—</span
                  >
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Actions"
                [width]="150"
                [minWidth]="150"
                *ngIf="
                  user_role.roles == 'admin' ||
                  user_role.roles == 'employee' ||
                  user_role.roles == 'extractor'
                "
              >
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center gap-2">
                    <!-- Menu and Start Class button for classes that have not started -->
                    <ng-container *ngIf="!row?.start_class; else classStarted">
                      <button
                        *ngIf="activeTab != 'pattern'"
                        class="btn btn-primary btn-sm glow mb-0"
                        (click)="startClass(row._id)"
                      >
                        {{ row?.start_class ? "Started" : "Start Class" }}
                      </button>
                      <button
                        mat-button
                        [matMenuTriggerFor]="menu1"
                        class="btn-actions-menu"
                      >
                        <i
                          class="ft-more-vertical text-primary cursor-pointer"
                        ></i>
                      </button>
                      <mat-menu #menu1="matMenu">
                        <button
                          *ngIf="activeTab == 'pattern'"
                          mat-menu-item
                          (click)="createPatternClass(row._id)"
                        >
                          <i class="ft-copy mr-1"></i> Create Duplicate Pattern
                        </button>
                        <button
                          *ngIf="activeTab == 'pattern'"
                          mat-menu-item
                          (click)="openPopup(row._id)"
                        >
                          <i class="ft-plus mr-1"></i> Create Class
                        </button>
                        <button mat-menu-item (click)="editClass(row)">
                          <i class="ft-edit mr-1"></i> Edit
                        </button>
                        <button
                          *ngIf="activeTab !== 'pattern'"
                          mat-menu-item
                          (click)="Delete(row._id)"
                        >
                          <i class="ft-trash-2 mr-1"></i> Delete
                        </button>
                        <!-- Activate/Deactivate buttons for pattern tab only -->
                        <button
                          *ngIf="activeTab == 'pattern' && !row?.isDeactivated"
                          mat-menu-item
                          (click)="deactivatePattern(row._id)"
                          class="text-warning"
                        >
                          <i class="ft-x-circle mr-1"></i> Deactivate Pattern
                        </button>
                        <button
                          *ngIf="activeTab == 'pattern' && row?.isDeactivated"
                          mat-menu-item
                          (click)="activatePattern(row._id)"
                          class="text-success"
                        >
                          <i class="ft-check-circle mr-1"></i> Activate Pattern
                        </button>
                      </mat-menu>
                    </ng-container>

                    <!-- Displayed when the class has started -->
                    <ng-template #classStarted>
                      <button
                        class="btn btn-secondary btn-sm glow mb-0"
                        disabled
                      >
                        Class Started
                      </button>
                    </ng-template>
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>

            <!-- Date Range Popup Modal -->
            <div *ngIf="showDatePopup" class="popup-backdrop">
              <div class="popup-container">
                <h3 class="mb-2">Select Date Range</h3>
                <div class="date-select-main">
                  <mat-form-field appearance="fill" class="date-field">
                    <mat-label class="date-label">From Date</mat-label>
                    <input
                      type="date"
                      matInput
                      [matDatepicker]="fromPicker"
                      [(ngModel)]="fromDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="fromPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="date-field">
                    <mat-label class="date-label">To Date</mat-label>
                    <input
                      type="date"
                      matInput
                      [matDatepicker]="toPicker"
                      [(ngModel)]="toDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="toPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                  </mat-form-field>

                  <div
                    class="popup-actions mt-3 d-flex justify-content-between"
                  >
                    <button class="btn btn-danger" (click)="closePopup()">
                      Cancel
                    </button>
                    <button class="btn btn-success" (click)="confirmPopup()">
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="showDatePopup1" class="popup-backdrop">
              <div class="popup-container">
                <h3 class="mb-2">Select Date Range</h3>
                <div class="date-select-main">
                  <mat-form-field appearance="fill" class="date-field">
                    <mat-label class="date-label">From Date</mat-label>
                    <input
                      type="date"
                      matInput
                      [matDatepicker]="fromPicker"
                      [(ngModel)]="fromDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="fromPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="fill" class="date-field">
                    <mat-label class="date-label">To Date</mat-label>
                    <input
                      type="date"
                      matInput
                      [matDatepicker]="toPicker"
                      [(ngModel)]="toDate"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="toPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="popup-actions mt-3 d-flex justify-content-between">
                  <button class="btn btn-danger" (click)="closePopups()">
                    Cancel
                  </button>
                  <button class="btn btn-success" (click)="confirmPopups()">
                    Generate
                  </button>
                </div>
              </div>
            </div>

            <ng-template #projectTagModal let-modal>
              <div class="modal-header">
                <h4 class="modal-title">Select Project Tag</h4>
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  (click)="modal.dismiss()"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <label>Project Tag</label>
                <ng-select
                  [items]="project_tags_list"
                  bindLabel="name"
                  bindValue="_id"
                  [(ngModel)]="selectedProjectTagId"
                  [ngModelOptions]="{ standalone: true }"
                  [searchable]="true"
                  placeholder="Select a tag"
                  [appendTo]="'body'"
                >
                </ng-select>
              </div>

              <div class="modal-footer">
                <button class="btn btn-secondary" (click)="modal.dismiss()">
                  Cancel
                </button>
                <button
                  class="btn btn-primary"
                  (click)="saveSelectedProjectTag(modal)"
                >
                  Save
                </button>
                <button
                  *ngIf="activeTab === 'pattern'"
                  class="btn btn-primary"
                  (click)="saveSelectedProjectTag(modal, 'sequence')"
                >
                  Sequence
                </button>
              </div>
            </ng-template>

            <ng-template #referenceModal let-modal>
              <div class="modal-header">
                <h4 class="modal-title">Add New Reference</h4>
                <button type="button" class="close" (click)="modal.dismiss()">
                  <span>&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Reference Name</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="newReference.name"
                  />
                </div>
                <div class="form-group">
                  <label>Reference Link</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="newReference.links"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" (click)="modal.dismiss()">
                  Cancel
                </button>
                <button class="btn btn-primary" (click)="addReference(modal)">
                  Add
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-------------- Add Reference Popup ------------------------------------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Add Reference</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="referenceForm" #refForm="ngForm">
        <div class="form-group">
          <label>Name<span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            [class.is-invalid]="
              refForm.submitted && referenceForm.controls.name.invalid
            "
            placeholder="Enter reference name"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="refForm.submitted && referenceForm.controls.name.invalid"
          >
            Name is required
          </div>
        </div>

        <div class="form-group">
          <label>Link<span class="text-danger">*</span></label>
          <input
            type="url"
            class="form-control"
            formControlName="links"
            [class.is-invalid]="
              refForm.submitted && referenceForm.controls.links.invalid
            "
            placeholder="Enter reference link (e.g., https://example.com)"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="refForm.submitted && referenceForm.controls.links.invalid"
          >
            Valid link is required
          </div>
        </div>

        <div class="form-group">
          <label>Description</label>
          <textarea
            class="form-control"
            formControlName="description"
            rows="2"
            placeholder="Enter description (optional)"
          ></textarea>
        </div>

        <div class="form-group">
          <label>Notes</label>
          <textarea
            class="form-control"
            formControlName="notes"
            rows="2"
            placeholder="Enter notes (optional)"
          ></textarea>
        </div>

        <div class="form-group">
          <label>Admin Notes</label>
          <textarea
            class="form-control"
            formControlName="admin_notes"
            rows="2"
            placeholder="Enter admin notes (optional)"
          ></textarea>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modalService.dismissAll()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="submitRef(refForm)"
      >
        Submit
      </button>
    </div>
  </ng-template>
</div>

<!-------------- Edit Reference Popup ------------------------------------------->
<div>
  <ng-template #myModal2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Reference</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="referenceForm" #editRefForm="ngForm">
        <div class="form-group">
          <label>Name<span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            [class.is-invalid]="
              editRefForm.submitted && referenceForm.controls.name.invalid
            "
            placeholder="Enter reference name"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="editRefForm.submitted && referenceForm.controls.name.invalid"
          >
            Name is required
          </div>
        </div>
        <div class="form-group">
          <label>Link<span class="text-danger">*</span></label>
          <input
            type="url"
            class="form-control"
            formControlName="links"
            [class.is-invalid]="
              editRefForm.submitted && referenceForm.controls.links.invalid
            "
            placeholder="Enter reference link (e.g., https://example.com)"
          />
          <div
            class="invalid-feedback d-block"
            *ngIf="
              editRefForm.submitted && referenceForm.controls.links.invalid
            "
          >
            Valid link is required
          </div>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea
            class="form-control"
            formControlName="description"
            rows="2"
            placeholder="Enter description (optional)"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Notes</label>
          <textarea
            class="form-control"
            formControlName="notes"
            rows="2"
            placeholder="Enter notes (optional)"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Admin Notes</label>
          <textarea
            class="form-control"
            formControlName="admin_notes"
            rows="2"
            placeholder="Enter admin notes (optional)"
          ></textarea>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modalService.dismissAll()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="updateRef(editRefForm)"
      >
        Update
      </button>
    </div>
  </ng-template>
</div>

<!---------- Add Update Student Popup ---------------->
<div>
  <ng-template #studentModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!class_id">Add Student</h4>
      <h4 class="modal-title" *ngIf="class_id">Update Student</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fieldset class="form-group my-1">
        <label>Student<span class="required_field">*</span></label>
        <ng-select
          [items]="student_list"
          bindLabel="name"
          bindValue="id"
          placeholder="Select Student"
          [(ngModel)]="select_student"
          [ngModelOptions]="{ standalone: true }"
          [closeOnSelect]="true"
          (change)="getStudentId($event)"
          [appendTo]="'body'"
          [virtualScroll]="true"
        >
        </ng-select>
      </fieldset>
      <fieldset class="form-group my-1">
        <label>Enrollment<span class="required_field">*</span></label>
        <ng-select
          [items]="enrollment_list"
          bindLabel="name"
          bindValue="_id"
          placeholder="Select Student"
          [(ngModel)]="select_enrollment"
          [ngModelOptions]="{ standalone: true }"
          [closeOnSelect]="true"
          (change)="getEnrollmentId($event)"
          [appendTo]="'body'"
          [virtualScroll]="true"
        >
        </ng-select>
      </fieldset>
      <fieldset class="form-group my-1">
        <label>Course<span class="required_field">*</span></label>
        <ng-select
          [items]="course_list"
          bindLabel="title"
          bindValue="_id"
          placeholder="Select course"
          [(ngModel)]="select_course"
          [ngModelOptions]="{ standalone: true }"
          [closeOnSelect]="false"
          (change)="getCourseId($event)"
          [appendTo]="'body'"
          [virtualScroll]="true"
        >
        </ng-select>
      </fieldset>
      <fieldset class="my-1">
        <input
          type="radio"
          name="radio"
          value="Session Wise"
          (change)="getRadioValue($event)"
        />
        Session Wise
        <input
          type="radio"
          name="radio"
          value="Topic Wise"
          (change)="getRadioValue($event)"
        />
        Topic Wise
      </fieldset>
      <fieldset class="form-group my-1" *ngIf="radio_button == 'Session Wise'">
        <label>Session</label>
        <ng-select
          [items]="session_list"
          bindLabel="title"
          placeholder="Select Session"
          [(ngModel)]="select_session"
          [ngModelOptions]="{ standalone: true }"
          [closeOnSelect]="true"
          (change)="getSessionId($event)"
        >
        </ng-select>
      </fieldset>
      <fieldset class="form-group my-1" *ngIf="radio_button == 'Topic Wise'">
        <label>Topics<span class="required_field">*</span></label>
        <ng-select
          [items]="topic_list"
          bindLabel="topic_name"
          bindValue="topic_id"
          placeholder="Select topic"
          [(ngModel)]="select_topic"
          [multiple]="true"
          [ngModelOptions]="{ standalone: true }"
          [closeOnSelect]="false"
          (change)="getTopicId($event)"
        >
        </ng-select>
      </fieldset>
    </div>

    <!-- <div class="modal-footer">
      <button *ngIf="!class_id" class="btn btn-primary" (click)="addStudent();modal.dismiss()">Submit</button>
      <button *ngIf="class_id" class="btn btn-primary" (click)="updateStudent();modal.dismiss()">Update</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
    </div> -->

    <div class="modal-footer">
      <button
        *ngIf="isNewClass()"
        class="btn btn-primary"
        (click)="addStudent(); modal.dismiss()"
      >
        Add Student
      </button>
      <button
        *ngIf="!isNewClass()"
        class="btn btn-primary"
        (click)="updateStudent(); modal.dismiss()"
      >
        Update
      </button>
      <button
        *ngIf="activeTab === 'pattern' && !isNewClass()"
        class="btn btn-primary"
        (click)="updateStudent('sequence'); modal.dismiss()"
      >
        Sequence
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modalService.dismissAll()"
      >
        Cancel
      </button>
    </div>
  </ng-template>
</div>

<ngx-spinner></ngx-spinner>
